import React from "react";
import { Box, Typography, Paper } from "@mui/material";
import { useTranslation } from "react-i18next";

const PaymentHistory = () => {
  const { t } = useTranslation();
  return (
    <Box className="p-4">
      <Paper className="p-6">
        <Typography variant="h5" gutterBottom>
          {t("ownerScreens.paymentHistory")}
        </Typography>
        <Typography variant="body1" color="text.secondary">
          {t("ownerScreens.paymentHistoryDesc")}
        </Typography>
      </Paper>
    </Box>
  );
};

export default PaymentHistory;
